'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { Root } from '@radix-ui/react-dropdown-menu';
const Dropdown = ({ children, ...props }) => {
    return (_jsx(Root, { modal: false, ...props, children: children }));
};
export { Dropdown };
